import { useParams, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function ProductCategory() {
  const { mainCategory, subCategory } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('urunler');

  const categoryData = {
    cıvatalar: {
      name: 'Cıvatalar',
      subCategories: {
        'imbus-civatalar': {
          name: 'İmbus Cıvatalar',
          description:
            'Allen başlı silindir cıvatalar, hassas montajlar için ideal',
          image:
            'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/eafcab84e3b708a8632aab98662b7571.png',
          products: [
            {
              id: 'din-912',
              name: 'DIN 912 - İmbus Cıvata',
              description: 'Silindir başlı allen cıvata, yüksek mukavemet',
              specs: 'M3-M64, 12.9 kalite sınıfı',
              material: 'Kalite: 8.8 - 10.9 - 12.9 / Paslanmaz',
              coating: 'Siyah Oksit, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-912-imbus-civata.jpg',
            },
            {
              id: 'din-7380',
              name: 'DIN 7380 - Bombe Başlı İmbus Cıvata',
              description: 'Bombe başlı imbus cıvata, estetik görünüm',
              specs: 'M3-M20, paslanmaz ve çelik',
              material: 'Kalite: 8.8 - 10.9 - 12.9 / Paslanmaz',
              coating: 'Siyah Oksit, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-7380-bombe-basli-imbus.jpg',
            },
            {
              id: 'din-7984',
              name: 'DIN 7984 - İnce Kafa İmbus Cıvata',
              description:
                'İnce kafa imbus cıvata, dar alan montajları',
              specs: 'M3-M16, düşük profil',
              material: 'Kalite: 8.8 - 10.9 - 12.9 / Paslanmaz',
              coating: 'Siyah Oksit, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-7984-ince-kafa-imbus.jpg',
            },
            {
              id: 'din-7991',
              name: 'DIN 7991 - Havşa Baş İmbus Cıvata',
              description:
                'Düz havşa başlı cıvata, yüzey montajları için ideal',
              specs: 'M4-M20, A2-A4 paslanmaz çelik',
              material: 'Kalite: 8.8 - 10.9 - 12.9 / Paslanmaz',
              coating: 'Doğal Paslanmaz',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-7991-havsa-bas-imbus.jpg',
            },
          ],
        },
        'akb-civatalar': {
          name: 'AKB Cıvatalar',
          description:
            'Altı köşe başlı cıvatalar, yapısal uygulamalar için',
          image:
            'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/77c208eb7f186b180289a290016e4ce7.jpeg',
          products: [
            {
              id: 'din-933',
              name: 'DIN 933 - Altı Köşe Tam Diş Cıvata',
              description:
                'Tam dişli altı köşe başlı cıvata, yüksek mukavemet sınıfı',
              specs: 'M6-M30, 8.8-12.9 kalite sınıfı',
              material: 'Kalite: 8.8 - 10.9 - 12.9 / Paslanmaz',
              coating: 'Galvaniz, Siyah Oksit, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-933-alti-kose-basli-civata.jpg',
            },
            {
              id: 'din-931',
              name: 'DIN 931 - Altı Köşe Yarım Diş Cıvata',
              description:
                'Kısmi dişli altı köşe başlı cıvata, yapısal uygulamalar',
              specs: 'M8-M36, 8.8-10.9 kalite sınıfı',
              material: 'Kalite: 8.8 - 10.9 - 12.9 / Paslanmaz',
              coating: 'Galvaniz, Sıcak Daldırma Galvaniz',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-931-alti-kose-basli-civata.jpg',
            },
            {
              id: 'din-960',
              name: 'DIN 960 - Altı Köşe İnce Diş Yarım Diş Cıvata',
              description:
                'İnce dişli yarım paso cıvata, hassas uygulamalar',
              specs: 'M8-M36, ince diş adımı',
              material: 'Kalite: 8.8 - 10.9 - 12.9 / Paslanmaz',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-960-ince-dis-civata.jpg',
            },
            {
              id: 'din-961',
              name: 'DIN 961 - Altı Köşe İnce Diş Tam Diş Cıvata',
              description:
                'İnce dişli tam paso cıvata, hassas montajlar',
              specs: 'M8-M36, ince diş adımı',
              material: 'Kalite: 8.8 - 10.9 - 12.9 / Paslanmaz',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-961-ince-dis-tam-civata.jpg',
            },
            {
              id: 'din-6914',
              name: 'DIN 6914 - Yüksek Mukavemetli Yapısal Cıvata',
              description:
                'Yüksek mukavemetli yapısal bağlantı cıvatası',
              specs: 'M12-M36, 10.9 kalite sınıfı',
              material: 'Kalite: 8.8 - 10.9 - 12.9 / Paslanmaz',
              coating: 'Sıcak Daldırma Galvaniz',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-6914-yapisal-civata.jpg',
            },
            {
              id: 'din-6921',
              name: 'DIN 6921 - Flanşlı Altı Köşe Başlı Cıvata',
              description:
                'Flanşlı altı köşe başlı cıvata, geniş yüzey teması',
              specs: 'M5-M20, entegre flanş',
              material: 'Kalite: 8.8 - 10.9 - 12.9 / Paslanmaz',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-6921-flansli-civata.jpg',
            },
            {
              id: 'din-7990',
              name: 'DIN 7990 - Altı Köşe Ağır Tip Cıvata',
              description:
                'Ağır tip altı köşe başlı cıvata, yüksek yük kapasitesi',
              specs: 'M12-M36, ağır tip yapı',
              material: 'Kalite: 8.8 - 10.9 - 12.9 / Paslanmaz',
              coating: 'Sıcak Daldırma Galvaniz',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-7990-agir-tip-civata.jpg',
            },
          ],
        },
        setskurlar: {
          name: 'Setskurlar',
          description: 'Sabitleme ve pozisyonlama cıvataları',
          image:
            'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/127f0e7f636a6711bb04d5da23fd52fd.webp',
          products: [
            {
              id: 'din-914',
              name: 'DIN 914 - Sivri Uçlu Setskur',
              description: 'Sivri uçlu setskur, hassas pozisyonlama',
              specs: 'M3-M12, sertleştirilmiş uç',
              material: 'Çelik 45H, Paslanmaz A2',
              coating: 'Siyah Oksit, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-914-sivri-uclu-setskur.jpg',
            },
            {
              id: 'din-915',
              name: 'DIN 915 - Bilye Uçlu Setskur',
              description: 'Bilye uçlu setskur, yumuşak sabitleme',
              specs: 'M3-M12, bilye uç',
              material: 'Çelik 45H, Paslanmaz A2',
              coating: 'Siyah Oksit, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-915-bilye-uclu-setskur.jpg',
            },
            {
              id: 'din-916',
              name: 'DIN 916 - Düz Uçlu Setskur',
              description: 'Düz uçlu setskur, genel sabitleme',
              specs: 'M3-M12, standart uç',
              material: 'Çelik 45H, Paslanmaz A2',
              coating: 'Siyah Oksit, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-916-duz-uclu-setskur.jpg',
            },
            {
              id: 'din-913',
              name: 'DIN 913 - Düz Uçlu Setskur',
              description: 'Düz uçlu setskur, alternatif model',
              specs: 'M3-M12, düz uç',
              material: 'Çelik 45H, Paslanmaz A2',
              coating: 'Siyah Oksit, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-913-duz-uclu-setskur.jpg',
            },
          ],
        },
        'diger-civatalar': {
          name: 'Diğer',
          description: 'Özel amaçlı cıvatalar',
          image:
            'https://readdy.ai/api/search-image?query=Special%20purpose%20bolts%20and%20fasteners%20including%20wing%20bolts%20eye%20bolts%20and%20custom%20designed%20bolts%20on%20dark%20industrial%20surface%2C%20professional%20photography%20showing%20variety%20of%20specialized%20fastening%20solutions&width=600&height=400&seq=diger-civata-detail&orientation=landscape',
          products: [
            {
              id: 'asme-b18-2-1',
              name: 'ASME B18.2.1 - Amerikan Standart Cıvata',
              description:
                'ASME standardında altı köşe başlı cıvata',
              specs: '1/4"-1", Grade 2-8',
              material: 'Çelik Grade 2, 5, 8',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/asme-b18-2-1-civata.jpg',
            },
            {
              id: 'unc-unf-bicak-civata',
              name: 'UNC/UNF Bıçak Cıvata',
              description: 'Amerikan standart bıçak dişli cıvata',
              specs: '1/4"-1", UNC/UNF diş',
              material: 'Çelik Grade 2, 5',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/unc-unf-bicak-civata.jpg',
            },
            {
              id: 'din-316',
              name: 'DIN 316 - Kelebek Başlı Cıvata',
              description: 'Kelebek başlı cıvata, el ile sıkma',
              specs: 'M4-M12, kelebek baş',
              material: 'Çelik, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-316-kelebek-basli-civata.jpg',
            },
            {
              id: 'din-444',
              name: 'DIN 444 - Gözlü Cıvata',
              description: 'Gözlü civata, kaldırma ve bağlama',
              specs: 'M6-M24, göz çapı değişken',
              material: 'Çelik, Paslanmaz A4',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-444-gozlu-civata.jpg',
            },
            {
              id: 'din-603',
              name: 'DIN 603 - Yuvarlak Başlı Dibi Dört Köşe Cıvata',
              description:
                'Yuvarlak başlı, dibi kare cıvata',
              specs: 'M5-M20, kare boyun',
              material: 'Çelik 4.6, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-603-yuvarlak-basli-civata.jpg',
            },
            {
              id: 'din-605',
              name: 'DIN 605 - Yuvarlak Başlı Kare Boyunlu Cıvata',
              description:
                'Yuvarlak başlı kare boyunlu cıvata',
              specs: 'M6-M20, kare boyun',
              material: 'Çelik 4.6, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-605-kare-boyunlu-civata.jpg',
            },
            {
              id: 'din-908',
              name: 'DIN 908 - Konik Dişli Tapa',
              description: 'Konik dişli tapa, sızdırmazlık',
              specs: 'M6-M33, konik diş',
              material: 'Çelik, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-908-konik-disli-tapa.jpg',
            },
            {
              id: 'din-910',
              name: 'DIN 910 - Silindirik Dişli Tapa',
              description: 'Silindirik dişli tapa, sızdırmazlık',
              specs: 'M6-M33, silindirik diş',
              material: 'Çelik, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-910-silindirik-disli-tapa.jpg',
            },
            {
              id: 'tava-civatasi',
              name: 'Tava Cıvatası',
              description: 'Tava başlı özel cıvata',
              specs: 'M6-M16, tava baş',
              material: 'Çelik, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/tava-civatasi.jpg',
            },
            {
              id: 'din-571',
              name: 'DIN 571 – Trifon Vida',
              description: 'Altı köşe başlı ağaç vidası',
              specs: '6-12mm çap, çeşitli uzunluklar',
              material: 'Çelik',
              coating: 'Galvaniz, Sarı Çinko',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-571-agac-vidasi.jpg',
            },
          ],
        },
      },
    },
    somunlar: {
      name: 'Somunlar',
      subCategories: {
        'standart-somunlar': {
          name: 'Standart Somunlar',
          description: 'Genel amaçlı somunlar',
          image:
            'https://readdy.ai/api/search-image?query=Standard%20hex%20nuts%20arranged%20systematically%20on%20dark%20industrial%20surface%2C%20professional%20product%20photography%20showing%20six-sided%20design%20and%20internal%20threading%2C%20various%20sizes%20with%20galvanized%20finish&width=600&height=400&seq=standart-somun&orientation=landscape',
          products: [
            {
              id: 'din-934',
              name: 'DIN 934 - Altı Köşe Somun',
              description:
                'Standart altı köşe somun, genel kullanım',
              specs: 'M3-M100, çelik ve paslanmaz seçenekler',
              material: 'Çelik 8, Paslanmaz A2-A4',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-934-alti-kose-somun.jpg',
            },
            {
              id: 'din-315',
              name: 'DIN 315 - Kelebek Somun',
              description:
                'El ile sıkılabilen kelebek somun',
              specs: 'M4-M12, kelebek kanat tasarımı',
              material: 'Çelik, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-315-kelebek-somun.jpg',
            },
            {
              id: 'din-439-2',
              name: 'DIN 439-2 - Altı Köşe Kontra Somun',
              description:
                'İnce kontra somun, gevşeme önleyici',
              specs: 'M3-M30, ince yapı',
              material: 'Çelik 8, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-439-2-kontra-somun.jpg',
            },
            {
              id: 'din-928',
              name: 'DIN 928 - Kaynak Somunu',
              description: 'Kaynak için özel tasarım somun',
              specs: 'M3-M16, kaynak çıkıntılı',
              material: 'Çelik',
              coating: 'Doğal, Galvaniz',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-928-kaynak-somunu.jpg',
            },
            {
              id: 'din-929',
              name: 'DIN 929 - Kaynak Somunu (Altı Köşe)',
              description: 'Altı köşe kaynak somunu',
              specs: 'M5-M20, altı köşe kaynak çıkıntılı',
              material: 'Çelik',
              coating: 'Doğal, Galvaniz',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-929-kaynak-somunu.jpg',
            },
            {
              id: 'din-936',
              name: 'DIN 936 - Altı Köşe Kontra Somun',
              description: 'Standart kontra somun, ince yapı',
              specs: 'M3-M30, kontra uygulamaları',
              material: 'Çelik 8, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-936-kontra-somun.jpg',
            },
            {
              id: 'din-980v',
              name: 'DIN 980/V - ISO 7042 – Sıkmalı Altı Köşe Somun',
              description:
                'Metal fiberli gevşeme önleyici somun',
              specs: 'M3-M20, metal fiber insert',
              material: 'Çelik 8, Metal Fiber',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-980v-metal-fiberli-somun.jpg',
            },
            {
              id: 'din-982',
              name: 'DIN 982 - Altıköşe Fiberli Somun (Yüksek Tip)',
              description:
                'Nylon fiberli gevşeme önleyici somun',
              specs: 'M3-M20, nylon fiber insert',
              material: 'Çelik 8, Nylon Fiber',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-982-nylon-fiberli-somun.jpg',
            },
            {
              id: 'din-985',
              name: 'DIN 985 - Altı Köşe Fiberli Somun',
              description:
                'Nylon fiberli altı köşe somun',
              specs: 'M3-M20, nylon fiber insert',
              material: 'Çelik 8, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-985-fiberli-somun.jpg',
            },
            {
              id: 'din-1587',
              name: 'DIN 1587 - Altı Köşe Kör Somun',
              description: 'Kör somun, kapalı uç',
              specs: 'M3-M20, kapalı uç tasarımı',
              material: 'Çelik, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-1587-kor-somun.jpg',
            },
            {
              id: 'din-1624',
              name: 'DIN 1624 - T Somunu',
              description: 'T şeklinde özel somun',
              specs: 'M6-M20, T profil uyumlu',
              material: 'Çelik',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-1624-t-somunu.jpg',
            },
            {
              id: 'din-6330',
              name: 'DIN 6330 - Takviyeli Somun',
              description: 'Yüksek boy altı köşe somun',
              specs: 'M8-M30, yüksek boy',
              material: 'Çelik 8, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-6330-yuksek-somun.jpg',
            },
            {
              id: 'din-6334',
              name: 'DIN 6334 - Altı Köşe Uzatma Somunu',
              description: 'Uzatma somunu, çift taraflı diş',
              specs: 'M6-M30, çift taraflı diş',
              material: 'Çelik, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-6334-uzatma-somunu.jpg',
            },
            {
              id: 'din-6915',
              name: 'DIN 6915 - Altıköşe Ağır Yük Somunu',
              description:
                'Yüksek mukavemetli yapısal bağlantı somunu',
              specs: 'M12-M36, 10 kalite sınıfı',
              material: 'Çelik 10',
              coating: 'Sıcak Daldırma Galvaniz',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-6915-yapisal-somun.jpg',
            },
            {
              id: 'din-6923',
              name: 'DIN 6923 - Altı Köşe Flanşlı Somun',
              description:
                'Flanşlı altı köşe somun, geniş yüzey teması',
              specs: 'M5-M20, entegre flanş',
              material: 'Çelik 8, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-6923-flansli-somun.jpg',
            },
            {
              id: 'din-6925',
              name: 'DIN 6925 - Sıkmalı Altıköşe Somun',
              description: 'Flanşlı nylon fiberli somun',
              specs: 'M5-M20, flanş + fiber',
              material: 'Çelik 8, Nylon Fiber',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-6925-flansli-fiberli-somun.jpg',
            },
            {
              id: 'din-6926',
              name: 'DIN 6926 - Flanşlı Fiberli Somun (Metal)',
              description:
                'Flanşlı metal fiberli somun',
              specs: 'M5-M20, flanş + metal fiber',
              material: 'Çelik 8, Metal Fiber',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-6926-flansli-metal-fiberli-somun.jpg',
            },
            {
              id: 'din-6927',
              name: 'DIN 6927 - Altıköşe Flanşlı Metal Sıkmalı Somun',
              description:
                'Flanşlı kör somun, kapalı uç',
              specs: 'M5-M20, flanş + kapalı uç',
              material: 'Çelik, Paslanmaz A2',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/din-6927-flansli-kor-somun.jpg',
            },
            {
              id: 'asme-b18-2-2',
              name: 'ASME B.18.2.2 - Altıköşe Somun Hexagon',
              description:
                'ASME standardında altıköşe somun',
              specs: '1/4"-1", Grade 2-8',
              material: 'Çelik Grade 2, 5, 8',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/asme-b18-2-2-somun.jpg',
            },
            {
              id: 'kafes-somunu',
              name: 'Kafes Somunu',
              description: 'Kafes yapısında özel somun',
              specs: 'M6-M20, kafes tasarım',
              material: 'Çelik',
              coating: 'Galvaniz, Doğalan',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/kafes-somunu.jpg',
            },
            {
              id: 'percin-somunu',
              name: 'Yuvarlak Gövde Flanslı Kafa Perçin Somunu',
              description: 'Perçinleme için özel somun',
              specs: 'M3-M12, perçin uyumlu',
              material: 'Çelik, Alüminyum',
              coating: 'Doğal, Anodize',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/percin-somunu.jpg',
            },
            {
              id: 'tablali-somun',
              name: 'Tablalı Somun',
              description: 'Tabla ile birleşik somun',
              specs: 'M6-M20, entegre tabla',
              material: 'Çelik',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/tablali-somun.jpg',
            },
          ],
        },
        'ozel-somunlar': {
          name: 'Özel Somun Tedariği',
          description:
            'Özel ihtiyaçlarınız için somun tedariği ve üretimi',
          image:
            'https://readdy.ai/api/search-image?query=Custom%20special%20nuts%20and%20specialized%20fasteners%20on%20dark%20industrial%20surface%2C%20professional%20photography%20showing%20various%20custom%20nut%20designs%20for%20specific%20applications%2C%20precision%20engineered%20solutions&width=600&height=400&seq=ozel-somun&orientation=landscape',
          products: [
            {
              id: 'ozel-tasarim-somun',
              name: 'Özel Tasarım Somun',
              description:
                'Müşteri ihtiyaçlarına göre özel tasarım somun üretimi',
              specs: 'Özel ölçüler, özel malzemeler',
              material: 'Çelik, Paslanmaz, Pirinç, Alüminyum',
              coating: 'İsteğe Göre',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/ozel-tasarim-somun.jpg',
            },
            {
              id: 'ozel-olcu-somun',
              name: 'Özel Ölçü Somun',
              description: 'Standart dışı ölçülerde somun üretimi',
              specs: 'Standart dışı ölçüler',
              material: 'Çelik, Paslanmaz',
              coating: 'Galvaniz, Doğal',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/ozel-olcu-somun.jpg',
            },
            {
              id: 'ozel-malzeme-somun',
              name: 'Özel Malzeme Somun',
              description: 'Özel malzemelerden somun üretimi',
              specs: 'Titanyum, İnkonel, Hastelloy',
              material: 'Özel Alaşımlar',
              coating: 'İsteğe Göre',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/ozel-malzeme-somun.jpg',
            },
            {
              id: 'prototip-somun',
              name: 'Prototip Somun',
              description: 'Prototip ve test amaçlı somun üretimi',
              specs: 'Küçük partiler, hızlı üretim',
              material: 'Çeşitli Malzemeler',
              coating: 'İsteğe Göre',
              autocadDrawing:
                'https://www.enkacivata.com/storage/teknik_cizim/prototip-somun.jpg',
            },
          ],
        },
      },
    },
    vidalar: {
      name: 'Vidalar',
      subCategories: {
        'ahsap-vidalari': {
          name: 'Ahşap Vidaları',
          description: 'Ahşap uygulamaları için vidalar',
          image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/dc873cc7a46f124394b0ccc7721c0231.jpeg',
          products: [
            {
              id: 'din-7505',
              name: 'DIN 7505 – Sunta Vidası',
              description: 'Sunta vidası, ahşap uygulamaları için',
              specs: 'Çeşitli boylar, kendinden dişli',
              material: 'Çelik',
              coating: 'Sarı Çinko, Galvaniz',
            },
            {
              id: 'din-571',
              name: 'DIN 571 – Trifon Vida',
              description: 'Altı köşe başlı ağaç vidası',
              specs: '6-12mm çap, çeşitli uzunluklar',
              material: 'Çelik',
              coating: 'Galvaniz, Sarı Çinko',
            },
            {
              id: 'mdf-vidasi',
              name: 'MDF Vidası',
              description: 'MDF ve yonga levha için özel vida',
              specs: 'Çeşitli boylar, özel diş yapısı',
              material: 'Çelik',
              coating: 'Sarı Çinko',
            },
            {
              id: 'crp-vidasi',
              name: 'CRP Vidası',
              description: 'Kompozit malzemeler için vida',
              specs: 'Özel diş yapısı, çeşitli boylar',
              material: 'Çelik',
              coating: 'Galvaniz',
            },
          ],
        },
        'metrik-vidalar': {
          name: 'Metrik Vidalar',
          description: 'Metrik diş sistemli vidalar',
          image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/0750993e18b74c2d8a1e9cbc6ffce0b7.jpeg',
          products: [
            {
              id: 'din-963',
              name: 'DIN 963',
              description: 'Metrik havşa başlı vida',
              specs: 'M3-M12, metrik diş',
              material: 'Çelik, Paslanmaz',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'din-84',
              name: 'DIN 84',
              description: 'Düz yarık silindir başlı vida',
              specs: 'M3-M12, silindir baş',
              material: 'Çelik, Paslanmaz',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'din-965',
              name: 'DIN 965',
              description: 'Yıldız havşa başlı vida',
              specs: 'M3-M12, Phillips baş',
              material: 'Çelik, Paslanmaz',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'din-7985',
              name: 'DIN 7985',
              description: 'Yıldız silindir başlı metrik vida',
              specs: 'M3-M12, Phillips silindir baş',
              material: 'Çelik, Paslanmaz',
              coating: 'Galvaniz, Doğal',
            },
          ],
        },
        'sac-vidalari': {
          name: 'Sac Vidaları',
          description: 'Metal sac için kendinden dişli vidalar',
          image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/23bcc818dddfe6ae8936cfa778274b6c.png',
          products: [
            {
              id: 'din-7971',
              name: 'DIN 7971',
              description: 'Silindir başlı sac vidası',
              specs: 'Kendinden dişli, çeşitli boylar',
              material: 'Çelik',
              coating: 'Galvaniz, Sarı Çinko',
            },
            {
              id: 'din-7981',
              name: 'DIN 7981',
              description: 'Yıldız silindir başlı sac vidası',
              specs: 'Phillips baş, kendinden dişli',
              material: 'Çelik',
              coating: 'Galvaniz, Sarı Çinko',
            },
            {
              id: 'din-7982',
              name: 'DIN 7982',
              description: 'Yıldız havşa başlı sac vidası',
              specs: 'Phillips havşa baş, kendinden dişli',
              material: 'Çelik',
              coating: 'Galvaniz, Sarı Çinko',
            },
            {
              id: 'din-7972',
              name: 'DIN 7972',
              description: 'Havşa Başlı Düz Tornavida Yarıklı Sac Vidası',
              specs: 'Kendinden dişli, çeşitli boylar',
              material: 'Çelik',
              coating: 'Galvaniz, Sarı Çinko',
            },
          ],
        },
        'matkap-uclu-vidalar': {
          name: 'Matkap Uçlu Vidalar',
          description: 'Kendinden delici vidalar',
          image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/da2faa7efb91f965a0cc4f0b143c843e.jpeg',
          products: [
            {
              id: 'din-7504p',
              name: 'DIN 7504P',
              description: 'Yıldız havşa başlı matkap uçlu vida',
              specs: 'Phillips havşa baş, matkap uçlu',
              material: 'Çelik',
              coating: 'Galvaniz',
            },
            {
              id: 'din-7504n',
              name: 'DIN 7504N',
              description: 'Yıldız silindir başlı matkap uçlu vida',
              specs: 'Phillips silindir baş, matkap uçlu',
              material: 'Çelik',
              coating: 'Galvaniz',
            },
            {
              id: 'din-7504k',
              name: 'DIN 7504K',
              description: 'Altı köşe pul başlı matkap uçlu vida',
              specs: 'Hex baş + pul, matkap uçlu',
              material: 'Çelik',
              coating: 'Galvaniz',
            },
            {
              id: 'poliuretan-panel-vidasi',
              name: 'Poliüretan Panel Vidası',
              description: 'Poliüretan panel montajı için özel vida',
              specs: 'Özel diş yapısı, matkap uçlu',
              material: 'Çelik',
              coating: 'Galvaniz',
            },
            {
              id: 'pulbasli-m-uclu-vida',
              name: 'Pulbaşlı M.Uçlu Vida',
              description: 'Pul başlı matkap uçlu vida',
              specs: 'Entegre pul, matkap uçlu',
              material: 'Çelik',
              coating: 'Galvaniz',
            },
            {
              id: 'm-uclu-alcipan-vidasi',
              name: 'M.Uçlu Alçıpan Vidası',
              description: 'Matkap uçlu alçıpan vidası',
              specs: 'Alçıpan için özel, matkap uçlu',
              material: 'Çelik',
              coating: 'Fosfat',
            },
            {
              id: 'sikdisli-alcipan-vida',
              name: 'Sıkdişli Alçıpan Vida',
              description: 'Sık dişli alçıpan vidası',
              specs: 'Sık diş yapısı, alçıpan için',
              material: 'Çelik',
              coating: 'Fosfat',
            },
            {
              id: 'seyrek-disli-alcipan-vida',
              name: 'Seyrek Dişli Alçıpan Vida',
              description: 'Seyrek dişli alçıpan vidası',
              specs: 'Seyrek diş yapısı, alçıpan için',
              material: 'Çelik',
              coating: 'Fosfat',
            },
            {
              id: 'konteyner-vidasi',
              name: 'Konteyner Vidası',
              description: 'Konteyner montajı için özel vida',
              specs: 'Yüksek mukavemet, özel diş',
              material: 'Çelik',
              coating: 'Galvaniz',
            },
            {
              id: 'kupeste-vidasi',
              name: 'Küpeşte Vidası',
              description: 'Küpeşte montajı için vida',
              specs: 'Dekoratif baş, özel diş',
              material: 'Çelik',
              coating: 'Galvaniz',
            },
            {
              id: 'ispanyolet-vidasi',
              name: 'İspanyolet Vidası',
              description: 'İspanyolet montajı için vida',
              specs: 'Özel baş tasarımı',
              material: 'Çelik',
              coating: 'Galvaniz',
            },
            {
              id: 'buldeks-vidasi',
              name: 'Buldeks Vidası',
              description: 'Buldeks montajı için özel vida',
              specs: 'Özel diş yapısı',
              material: 'Çelik',
              coating: 'Galvaniz',
            },
            {
              id: 'beton-vidasi',
              name: 'Beton Vidası',
              description: 'Beton uygulamaları için vida',
              specs: 'Yüksek mukavemet, özel uç',
              material: 'Çelik',
              coating: 'Galvaniz',
            },
          ],
        },
      },
    },
    rondelalar: {
      name: 'Rondelalar',
      subCategories: {
        'rondelalar': {
          name: 'Rondelalar',
          description: 'Düz ve yaylı rondela çeşitleri',
          image: 'https://readdy.ai/api/search-image?query=Various%20types%20of%20washers%20including%20flat%20washers%20spring%20washers%20and%20lock%20washers%20arranged%20on%20dark%20industrial%20surface%2C%20professional%20product%20photography%20showing%20different%20sizes%20and%20finishes%2C%20stainless%20steel%20and%20zinc%20plated%20washers%20with%20precise%20manufacturing%20quality&width=600&height=400&seq=all-washers&orientation=landscape',
          products: [
            {
              id: 'din-125-a',
              name: 'DIN 125/A',
              description: 'Düz rondela - Pul',
              specs: 'M3-M100, standart kalınlık',
              material: 'Çelik, Paslanmaz A2-A4',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'din-126',
              name: 'DIN 126',
              description: 'Düz altı köşe başlı cıvata ve somunlar için rondela',
              specs: 'Altı köşe uyumlu, çeşitli boylar',
              material: 'Çelik, Paslanmaz',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'din-127-b',
              name: 'DIN 127/B',
              description: 'Yaylı rondela',
              specs: 'M3-M100, yay çeliği',
              material: 'Yay Çeliği, Paslanmaz',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'din-128-b',
              name: 'DIN 128/B',
              description: 'Yaylı rondela 2',
              specs: 'Alternatif yaylı rondela',
              material: 'Yay Çeliği',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'din-137-b',
              name: 'DIN 137/B',
              description: 'Eğri yaylı rondela',
              specs: 'Eğri yapı, yay etkisi',
              material: 'Yay Çeliği',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'din-434',
              name: 'DIN 434',
              description: 'Dörtköşe Pul U Tipi',
              specs: 'Kare şekil, özel uygulamalar',
              material: 'Çelik',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'din-435',
              name: 'DIN 435',
              description: 'Dörtköşe Pul I Tipi',
              specs: 'Kare eğimli yapı',
              material: 'Çelik',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'din-6796',
              name: 'DIN 6796',
              description: 'Çanak rondela',
              specs: 'Çanak şekli, yay etkisi',
              material: 'Yay Çeliği',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'din-6798-a',
              name: 'DIN 6798/A',
              description: 'Tırtıllı rondela (Dıştan)',
              specs: 'Dış tırtıl, kaymaz',
              material: 'Çelik',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'din-6916',
              name: 'DIN 6916',
              description: 'Yüksek mukavemetli yapısal rondela',
              specs: 'Yapısal uygulamalar, yüksek mukavemet',
              material: 'Çelik',
              coating: 'Sıcak Daldırma Galvaniz',
            },
            {
              id: 'din-9021',
              name: 'DIN 9021',
              description: 'Geniş pul düz dış çap',
              specs: 'Geniş çap, düz yapı',
              material: 'Çelik, Paslanmaz',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'inch-yayli-rondela',
              name: 'INCH YAYLI RONDELA',
              description: 'İnç ölçülerinde yaylı rondela',
              specs: 'İnç ölçüleri, yay çeliği',
              material: 'Yay Çeliği',
              coating: 'Galvaniz, Doğal',
            },
            {
              id: 'inch-duz-rondela',
              name: 'INCH DUZ RONDELA',
              description: 'İnç ölçülerinde düz rondela',
              specs: 'İnç ölçüleri, standart kalınlık',
              material: 'Çelik',
              coating: 'Galvaniz, Doğal',
            },
          ],
        },
      },
    },
  };

  const currentCategory = categoryData[mainCategory];
  const currentSubCategory = currentCategory?.subCategories[subCategory];

  if (!currentCategory || !currentSubCategory) {
    return (
      <div className="min-h-screen">
        <Header />
        <main className="py-20">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-3xl font-bold text-slate-800 mb-4">
              Kategori Bulunamadı
            </h1>
            <p className="text-gray-600 mb-8">
              Aradığınız kategori mevcut değil.
            </p>
            <Button onClick={() => navigate('/urunler')}>Ürünlere Geri Dön</Button>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const tabs = [
    { id: 'urunler', label: 'Ürünler', icon: 'ri-list-check' },
    { id: 'teknik-bilgiler', label: 'Teknik Bilgiler', icon: 'ri-settings-line' },
    { id: 'olcu-tablolari', label: 'Ölçü Tabloları', icon: 'ri-table-line' },
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Breadcrumb */}
        <section className="py-4 bg-gray-50">
          <div className="container mx-auto px-4">
            <nav className="flex items-center space-x-2 text-sm">
              <button
                onClick={() => navigate('/')}
                className="text-gray-500 hover:text-orange-500 cursor-pointer transition-colors duration-200"
              >
                Ana Sayfa
              </button>
              <i className="ri-arrow-right-s-line text-gray-400"></i>
              <button
                onClick={() => navigate('/urunler')}
                className="text-gray-500 hover:text-orange-500 cursor-pointer transition-colors duration-200"
              >
                Ürünler
              </button>
              <i className="ri-arrow-right-s-line text-gray-400"></i>
              <button
                onClick={() => navigate('/urunler')}
                className="text-gray-500 hover:text-orange-500 cursor-pointer transition-colors duration-200"
              >
                {currentCategory.name}
              </button>
              <i className="ri-arrow-right-s-line text-gray-400"></i>
              <span className="text-orange-500 font-medium">
                {currentSubCategory.name}
              </span>
            </nav>
          </div>
        </section>

        {/* Category Header */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <img
                  src={currentSubCategory.image}
                  alt={currentSubCategory.name}
                  className="w-full h-96 object-cover object-center rounded-lg shadow-lg"
                />
              </div>
              <div className="flex flex-col justify-center">
                <h1 className="text-4xl font-bold text-slate-800 mb-4">
                  {currentSubCategory.name}
                </h1>
                <p className="text-xl text-gray-600 mb-6">
                  {currentSubCategory.description}
                </p>
                <div className="flex items-center space-x-4 mb-6">
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                    {currentSubCategory.products.length} Ürün Çeşidi
                  </span>
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                    DIN/ISO Standartları
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Tabs */}
        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            {/* Tab Navigation */}
            <div className="flex justify-center mb-8 overflow-x-auto">
              <div className="flex bg-white rounded-lg p-1 shadow min-w-max">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center px-6 py-4 rounded-lg text-base font-bold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      activeTab === tab.id
                        ? 'bg-orange-500 text-white border-b-2 border-orange-500'
                        : 'text-slate-800 hover:text-orange-500 hover:bg-orange-50'
                    }`}
                  >
                    <i className={`${tab.icon} mr-2`}></i>
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Tab Content */}
            <div className="max-w-6xl mx-auto">
              {activeTab === 'urunler' && (
                <>
                  {subCategory === 'ozel-somunlar' ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
                        <div className="p-6">
                          <h3 className="text-xl font-bold text-slate-800 mb-2">
                            Özel Tasarım Somun
                          </h3>
                          <p className="text-gray-600 mb-3">
                            Müşteri ihtiyaçlarına göre özel tasarım somun üretimi
                          </p>
                          <div className="bg-gray-50 p-3 rounded mb-4">
                            <p className="text-sm text-gray-700 mb-1">
                              <strong>Malzeme:</strong> Çelik, Paslanmaz, Pirinç, Alüminyum
                            </p>
                            <p className="text-sm text-gray-700">
                              <strong>Kaplama:</strong> İsteğe Göre
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
                        <div className="p-6">
                          <h3 className="text-xl font-bold text-slate-800 mb-2">
                            Özel Ölçü Somun
                          </h3>
                          <p className="text-gray-600 mb-3">
                            Standart dışı ölçülerde somun üretimi
                          </p>
                          <div className="bg-gray-50 p-3 rounded mb-4">
                            <p className="text-sm text-gray-700 mb-1">
                              <strong>Malzeme:</strong> Çelik, Paslanmaz
                            </p>
                            <p className="text-sm text-gray-700">
                              <strong>Kaplama:</strong> Galvaniz, Doğal
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
                        <div className="p-6">
                          <h3 className="text-xl font-bold text-slate-800 mb-2">
                            Özel Malzeme Somun
                          </h3>
                          <p className="text-gray-600 mb-3">
                            Özel malzemelerden somun üretimi
                          </p>
                          <div className="bg-gray-50 p-3 rounded mb-4">
                            <p className="text-sm text-gray-700 mb-1">
                              <strong>Malzeme:</strong> Titanyum, İnkonel, Hastelloy
                            </p>
                            <p className="text-sm text-gray-700">
                              <strong>Kaplama:</strong> İsteğe Göre
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                      {currentSubCategory.products.map((product, index) => (
                        <div
                          key={index}
                          className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300"
                        >
                          <div className="p-6">
                            <h3 className="text-xl font-bold text-slate-800 mb-2">
                              {product.name}
                            </h3>
                            <p className="text-gray-600 mb-3">
                              {product.description}
                            </p>
                            <div className="bg-gray-50 p-3 rounded mb-4">
                              <p className="text-sm text-gray-700 mb-1">
                                <strong>Malzeme:</strong> {product.material}
                              </p>
                              <p className="text-sm text-gray-700">
                                <strong>Kaplama:</strong> {product.coating}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}

              {activeTab === 'teknik-bilgiler' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">
                    Teknik Bilgiler
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {currentSubCategory.products.map((product, index) => (
                      <div
                        key={index}
                        className="border border-gray-200 rounded-lg p-6"
                      >
                        <h4 className="text-lg font-semibold text-slate-800 mb-4">
                          {product.name}
                        </h4>
                        <div className="space-y-3">
                          <div className="bg-gray-50 p-3 rounded">
                            <div className="font-semibold text-slate-800 mb-1">
                              Malzeme
                            </div>
                            <div className="text-gray-700 text-sm">
                              {product.material}
                            </div>
                          </div>
                          <div className="bg-gray-50 p-3 rounded">
                            <div className="font-semibold text-slate-800 mb-1">
                              Kaplama
                            </div>
                            <div className="text-gray-700 text-sm">
                              {product.coating}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {activeTab === 'olcu-tablolari' && subCategory === 'akb-civatalar' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">
                    Ölçü Tabloları
                  </h3>
                  <div className="text-center mb-8">
                    <a
                      href="https://drive.google.com/file/d/1DaTTV3Z6SVy0fg3pJzFdIYjnbqfIren4/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-download-line mr-2"></i>
                      Teknik Ölçü Tablosunu İndir (PDF)
                    </a>
                  </div>
                </div>
              )}

              {activeTab === 'olcu-tablolari' && subCategory === 'imbus-civatalar' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">
                    Ölçü Tabloları
                  </h3>
                  <div className="text-center mb-8">
                    <a
                      href="https://drive.google.com/file/d/1RDft2eW4GtHOMFSbPmRi71U2Zk-zDdTG/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-download-line mr-2"></i>
                      Teknik Ölçü Tablosunu İndir (PDF)
                    </a>
                  </div>
                </div>
              )}

              {activeTab === 'olcu-tablolari' && subCategory === 'setskurlar' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">
                    Ölçü Tabloları
                  </h3>
                  <div className="text-center mb-8">
                    <a
                      href="https://drive.google.com/file/d/1kl-I70nEjTJklWONitAyTNIYCRJmkJVc/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-download-line mr-2"></i>
                      Teknik Ölçü Tablosunu İndir (PDF)
                    </a>
                  </div>
                </div>
              )}

              {activeTab === 'olcu-tablolari' && subCategory === 'diger-civatalar' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">
                    Ölçü Tabloları
                  </h3>
                  <div className="text-center mb-8">
                    <a
                      href="https://drive.google.com/file/d/1ogJSjQDUnc3cZVenZrzou03yEHQBttqX/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-download-line mr-2"></i>
                      Teknik Ölçü Tablosunu İndir (PDF)
                    </a>
                  </div>
                </div>
              )}

              {activeTab === 'olcu-tablolari' && subCategory === 'standart-somunlar' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">
                    Ölçü Tabloları
                  </h3>
                  <div className="text-center mb-8">
                    <a
                      href="https://drive.google.com/file/d/1jq4GX1uMWea7jDVRINpLfjON877R5Mzu/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-download-line mr-2"></i>
                      Teknik Ölçü Tablosunu İndir (PDF)
                    </a>
                  </div>
                </div>
              )}

              {activeTab === 'olcu-tablolari' && subCategory === 'ahsap-vidalari' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">
                    Ölçü Tabloları
                  </h3>
                  <div className="text-center mb-8">
                    <a
                      href="https://drive.google.com/file/d/1Q1Il3gcET6I6iksYTMk7e4CqCcqagead/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-download-line mr-2"></i>
                      Teknik Ölçü Tablosunu İndir (PDF)
                    </a>
                  </div>
                </div>
              )}

              {activeTab === 'olcu-tablolari' && subCategory === 'matkap-uclu-vidalar' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">
                    Ölçü Tabloları
                  </h3>
                  <div className="text-center mb-8">
                    <a
                      href="https://drive.google.com/file/d/1XK4vNqLLWyP7soC-sSaevo5VFaOytrAn/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-download-line mr-2"></i>
                      Teknik Ölçü Tablosunu İndir (PDF)
                    </a>
                  </div>
                </div>
              )}

              {activeTab === 'olcu-tablolari' && subCategory === 'metrik-vidalar' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">
                    Ölçü Tabloları
                  </h3>
                  <div className="text-center mb-8">
                    <a
                      href="https://drive.google.com/file/d/1h-aHmq9JmZmuOMKhwJJRbJCajNzpEKkA/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-download-line mr-2"></i>
                      Teknik Ölçü Tablosunu İndir (PDF)
                    </a>
                  </div>
                </div>
              )}

              {activeTab === 'olcu-tablolari' && subCategory === 'sac-vidalari' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">
                    Ölçü Tabloları
                  </h3>
                  <div className="text-center mb-8">
                    <a
                      href="https://drive.google.com/file/d/1LfrgjhhBdHGpGaBe5xmCOrfYHVpI4THq/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-download-line mr-2"></i>
                      Teknik Ölçü Tablosunu İndir (PDF)
                    </a>
                  </div>
                </div>
              )}

              {activeTab === 'olcu-tablolari' && subCategory === 'rondelalar' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">
                    Ölçü Tabloları
                  </h3>
                  <div className="text-center mb-8">
                    <a
                      href="https://drive.google.com/file/d/1_SjE5ZEMAH-WfrtjPuCliMGK7HEv3QwH/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-download-line mr-2"></i>
                      Teknik Ölçü Tablosunu İndir (PDF)
                    </a>
                  </div>
                </div>
              )}

              {activeTab === 'olcu-tablolari' && subCategory === 'ozel-somunlar' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">
                    Ölçü Tabloları
                  </h3>
                  <div className="text-center py-12">
                    <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-table-line text-2xl text-gray-400"></i>
                    </div>
                    <h4 className="text-lg font-semibold text-gray-600 mb-2">
                      Özel Ürün Ölçü Tabloları
                    </h4>
                    <p className="text-gray-500">
                      Özel somun tedariği için ölçü tabloları müşteri
                      ihtiyaçlarına göre hazırlanmaktadır.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}